import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=24b924cc&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"
import style0 from "./Preferences.vue?vue&type=style&index=0&id=24b924cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b924cc",
  null
  
)

export default component.exports